import React, { useState } from "react";
import styles from "./AddRegister.module.css";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import { IoCalendarOutline } from "react-icons/io5";

const AddRegister = () => {
  const dispatch = useDispatch();
    const [body, setBody] = useState('');
  const [formData, setFormData] = useState({
    title: "",
    template: "",
    replyTo: "",
    subject: "",
    description: "",
    when: "",
    generateFor: "",
  });

  const [sendNotification, setSendNotification] = useState(false); // ✅ add this

  const handleChange = (field) => (e) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleCancel = () => dispatch(closeModal());

  const handleSave = () => {
    if (
      !formData.title ||
      !formData.replyTo ||
      !formData.subject ||
      !formData.description ||
      !formData.when
    ) {
      alert("Please fill all required fields.");
      return;
    }
    console.log("Register data submitted:", formData);
    dispatch(closeModal());
  };

  return (
    <div className={styles.modal}>
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<IoCalendarOutline/>} // calendar icon
          heading="Add Register"
        />
        <ToClose onClose={handleCancel} />
      </div>

      <div className={styles.content}>
        <HeadingAndData
          label="Title"
          name="title"
          placeholder="Set Register Name"
          value={formData.title}
          onChange={handleChange("title")}
          required
        />

        <HeadingAndDropDown
          label="Template"
          name="template"
          value={formData.template}
          onChange={handleChange("template")}
          options={[
            { label: "Template A", value: "templateA" },
            { label: "Template B", value: "templateB" },
          ]}
        />

        <HeadingAndData
          label="Reply to"
          name="replyTo"
          placeholder="Set Register Name"
          value={formData.replyTo}
          onChange={handleChange("replyTo")}
          required
        />

        <HeadingAndData
          label="Subject"
          name="subject"
          placeholder="Set Register Name"
          value={formData.subject}
          onChange={handleChange("subject")}
          required
        />

        <div className={styles.inputBlock}>
          <label htmlFor="body" className={styles.inputLabel}>
            Description *
          </label>
          <textarea
            id="body"
            name="body"
            className={styles.textarea}
            placeholder="Enter the description here"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            required
          ></textarea>
        </div>

        <HeadingAndDropDown
          label="When"
          name="when"
          value={formData.when}
          onChange={handleChange("when")}
          required
          options={[
            { label: "Creation Day", value: "creationDay" },
            { label: "Due Date", value: "dueDate" },
          ]}
        />

        <HeadingAndDropDown
          label="Generate for"
          name="generateFor"
          value={formData.generateFor}
          onChange={handleChange("generateFor")}
          options={[
            { label: "Invoice due date", value: "invoiceDue" },
            { label: "Enrollment", value: "enrollment" },
          ]}
        />

        <div className={styles.actions}>
          <div className={styles.notificationWrapper}>
            <input
              type="checkbox"
              checked={sendNotification}
              onChange={(e) => setSendNotification(e.target.checked)}
            />
            <label>Send Notification</label>
          </div>

          <SaveAndCancel onCancel={handleCancel} onSave={handleSave} />
        </div>
      </div>
    </div>
  );
};

export default AddRegister;
